import React, { useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';

const NotificationBlockWarning = () => {
  const [show, setShow] = useState(true);

  if (!show) return null;

  return (
    <Alert
      variant="warning"
      dismissible
      onClose={() => setShow(false)}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1050,
        maxWidth: '350px',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <FontAwesomeIcon icon={faWarning} style={{ marginRight: '10px', fontSize: '1.5em', color: '#856404' }} />
        <strong>Προειδοποίηση!</strong>
        <div>
          <p style={{ marginBottom: '0.5rem', marginTop: '0.5rem' }}>
            Η συνδρομή σας πρόκειται να λήξει στο τέλος του μήνα. Μετά τη λήξη της, ο λογαριασμός σας θα μεταβεί σε περιορισμένη λειτουργία, με περιορισμένη πρόσβαση στις υπηρεσίες και χωρίς δυνατότητα νέων παραγγελιών. Επικοινωνήστε με την διαχείριση για την πληρωμή της συνδρομής σας.
          </p>
        </div>
      </div>
      <Button
        onClick={() => setShow(false)}
        variant="outline-secondary"
        size="sm"
        style={{ marginTop: '10px', display: 'block', width: '100%' }}
      >
        Κλείσιμο
      </Button>
    </Alert>
  );
};

export default NotificationBlockWarning;
